export const required = (value) => (value ? undefined : "Campo Obrigatório");

export const selected = (value) => (value ? undefined : "Opção Inexistente");

export const minLength = (min) => (value) =>
  value && value.length < min ? `Campo Incompleto` : undefined;

export const minLength6 = minLength(6);

export const minLength13 = minLength(13);

export const minLength14 = minLength(14);

export const minLength18 = minLength(18);

export const minLength25 = minLength(25);

export const email = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
    ? "Email Inválido"
    : undefined;

export const validatePassword = (password) =>
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/gm.test(
    password
  )
    ? undefined
    : "Sua senha necessita ter no mínimo 8 caracteres, 1 letra maiúscula, 1 letra minúscula, 1 número e 1 caracter especial.";

export const daysDifference = (date) => {
  let today = new Date();
  let otherDate = new Date(date);
  let timeInMilisec = today.getTime() - otherDate.getTime();
  let daysBetweenDates = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));
  return daysBetweenDates;
};
